import { useSelector } from "react-redux";
import { FirebaseState } from "../../utilities/firebaseState";
import { ProjectState } from "../project/slice";

export const useHeaderBarState = () => {
    return useSelector(
        (state: { firebase: FirebaseState; project: ProjectState }) => state
    );
};
